<template>
  <section class="c-card-grid">
    <div class="c-card-grid__inner" ref="container">
      <slot name="card"></slot>
    </div>
    <div class="c-card-grid__toggle" v-if="toggleable">
      <button type="button" class="c-card-grid__toggle-action" @click="toggle">{{ t(folded ? 'View all' : 'Show Less') }}</button>
    </div>
  </section>
</template>
<script lang="ts">
import { EventBus } from '../helpers/bus';
import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class CardGridToggle extends BaseComponent {
  public readonly $refs: { container: any };

  /**
   * How many rows should be shown by default
   */
  @Prop({ type: Number, default: null }) protected readonly rows: number | null;

  protected toggleable: boolean = false;

  protected folded: boolean = true;

  protected get cards() {
    return this.$slots.card ?? [];
  }

  protected getItemsPerRow(): number | null {
    const v = parseInt(window.getComputedStyle(this.$refs.container).getPropertyValue('--c-card-per-row'));

    return Number.isInteger(v) ? v : null;
  }

  protected getItemsToShow(): number {
    return (this.rows || 0) * (this.getItemsPerRow() || 0);
  }

  protected mounted(): void {
    if (!this.rows || !this.getItemsPerRow()) {
      return;
    }
    this.onResize();
    EventBus.$on('windowResize', this.onResize);
  }

  protected onResize(): void {
    this.toggleable = this.cards.length > this.getItemsToShow();
    this.update();
  }

  protected toggle(): void {
    this.folded = !this.folded;
    this.update();
  }

  protected update(): void {
    const itemsToShow = this.folded && this.toggleable ? this.getItemsToShow() : Infinity;
    this.cards.forEach((c, idx) => (c.elm as HTMLElement).classList.toggle('c-card-grid__toggle-hidden', idx >= itemsToShow));
  }
}
</script>
